import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface UnregisterDialogData {
  eventName: string;
}

export interface UnregisterDialogResult {
  confirmed: boolean;
  excuseText: string;
}

@Component({
  selector: 'app-calendar-event-unregister-dialog',
  templateUrl: './calendar-event-unregister-dialog.component.html',
  styleUrls: ['./calendar-event-unregister-dialog.component.css'],
})
export class CalendarEventUnregisterDialogComponent {
  excuseText: string = '';

  constructor(
    public dialogRef: MatDialogRef<CalendarEventUnregisterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnregisterDialogData
  ) {}

  isValid(): boolean {
    return this.excuseText.trim().length > 0;
  }

  onConfirm(): void {
    if (!this.isValid()) {
      return;
    }

    this.dialogRef.close({
      confirmed: true,
      excuseText: this.excuseText.trim(),
    } as UnregisterDialogResult);
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false, excuseText: '' } as UnregisterDialogResult);
  }
}
